<template>
	<StatusTag v-if="showStatus" :meta />

	<GestationalPeriodTag v-if="meta.status === 'PREGNANCY' && meta.gestational_period" size="small" :meta />
	<LastPeriodTag v-if="meta.status === 'FERTILITY' && meta.last_period" size="small" :meta />
	<LastPeriodMenopauseTag
		v-if="meta.status === 'MENOPAUSE' && meta.start_date_last_menstruation"
		size="small"
		:meta
	/>
	<AbortionDateTag v-if="isAbortionDateTagAvailable" size="small" :meta />
	<PregnancyEndedTag v-if="meta.status === 'POST_PARTUM' && meta.pregnancy_ended" size="small" :meta />
	<DeliveryDateTag v-if="meta.status === 'PREGNANCY' && meta.delivery_date" size="small" :meta />
	<MotherWeightTag v-if="meta.status === 'PREGNANCY' && meta.last_weight && meta.start_weight" size="small" :meta />
	<DeliveryTypeTag v-if="meta.status === 'POST_PARTUM'" size="small" :meta />
	<TwinsTag v-if="meta.status === 'POST_PARTUM' && !meta.singleton" size="small" :meta />
	<AbortionAgeTag v-if="isAbortionAgeTagAvailable" size="small" :meta />
</template>

<script setup lang="ts">
import type { PatientMeta } from "@/types/patient"
import { computed } from "vue"
import AbortionAgeTag from "./tags/AbortionAge.vue"
import AbortionDateTag from "./tags/AbortionDate.vue"
import DeliveryDateTag from "./tags/DeliveryDate.vue"
import DeliveryTypeTag from "./tags/DeliveryType.vue"
import GestationalPeriodTag from "./tags/GestationalPeriod.vue"
import LastPeriodTag from "./tags/LastPeriod.vue"
import LastPeriodMenopauseTag from "./tags/LastPeriodMenopause.vue"
import MotherWeightTag from "./tags/MotherWeight.vue"
import PregnancyEndedTag from "./tags/PregnancyEnded.vue"
import StatusTag from "./tags/Status.vue"
import TwinsTag from "./tags/Twins.vue"

const { meta, showStatus } = defineProps<{ meta: PatientMeta; showStatus?: boolean }>()

const isAbortionDateTagAvailable = computed(
	() =>
		(meta.status === "NATURAL_ABORTION" ||
			meta.status === "VOLUNTARY_ABORTION" ||
			meta.status === "UNKNOWN_ABORTION") &&
		meta.abortion_date
)

const isAbortionAgeTagAvailable = computed(
	() =>
		(meta.status === "NATURAL_ABORTION" ||
			meta.status === "VOLUNTARY_ABORTION" ||
			meta.status === "UNKNOWN_ABORTION") &&
		meta.abortion_gestational_period
)
</script>
